<md-dialog>
	<div md-dialog-header>
		<md-icon icon="untitled-ui/time/clock-refresh"></md-icon>
		<h2>Confirm Time Zone</h2>
	</div>

	<div class="content">
		<span><b>Please confirm your primary / home time zone.</b></span>

		@if (deviceTimezone()) {
			<div class="device-timezone-banner" [class.selected]="isDeviceTimezoneSelected()">
				<div class="device-info">
					<md-icon icon="untitled-ui/media/monitor-01"></md-icon>
					<span
						>Your device: <b>{{ bannerTimezoneLabel() }}</b></span
					>
				</div>
				@if (isDeviceTimezoneSelected()) {
					<span class="device-selected-badge">
						<md-icon icon="untitled-ui/general/check-circle"></md-icon>
						Matching
					</span>
				} @else {
					<button md-button class="use-this-btn" (click)="useDeviceTimezone()">Use this</button>
				}
			</div>
		}

		<lb-timezone-dropdown [value]="selectedTimezone()" (change)="onTimezoneChange($event)"></lb-timezone-dropdown>
	</div>

	<div md-dialog-footer>
		<button md-button-brand [disabled]="selectedTimezone() === null || isConfirming()" (click)="confirmTimezone()">
			@if (isConfirming()) {
				<span>Confirming...</span>
			} @else {
				<span>Confirm</span>
			}
		</button>
	</div>
</md-dialog>
